module.exports = __webpack_public_path__ + "static/media/temperature-up.4db44628.svg";